import styled from 'styled-components'

export const Title = styled.h1`
	margin: 4px 0 0;
	font-size: 18px;
	line-height: 18px;
	font-weight: 400;
`
